import { Injectable } from '@angular/core';
import { CanActivate, CanLoad } from '@angular/router';
import { Store } from '@ngrx/store';
import * as AuthenticationActions from '../../screens/login/state/login.actions';
import * as fromAuthentication from '../../screens/login/state/login.selectors';
import { Observable ,  from } from 'rxjs';
import { IUserStatus, LGEDataService } from '..';
import { map, take } from 'rxjs/operators';

@Injectable()
export class PendingGuard implements CanActivate, CanLoad {
  constructor(private store: Store<fromAuthentication.State>, private lgeDataService: LGEDataService) { }

  canActivate(): Observable<boolean> {
      return from(this.lgeDataService.getRegisteredStatus()).pipe(
          map((status: IUserStatus) => {
            if (status.pending && !status.approved) {
              // Registered and not approved so they can see the pending screen
              return true;
            } else {
              this.store.dispatch(new AuthenticationActions.LoginRedirect());
              return false;
            }
          }),
          take(1)
      )
  }

  canLoad(): Observable<boolean> {
    return this.canActivate();
  }

}